import { useEffect } from 'react'
import { useAppDispatch } from '@/store'
import { refreshReasonsForNotCompletedOrdersSettings } from '@/features/domain/territory'

export function useRefreshReasonsForNotCompletedOrders() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    async function refresh() {
      const result = await dispatch(refreshReasonsForNotCompletedOrdersSettings())

      if (refreshReasonsForNotCompletedOrdersSettings.rejected.match(result)) {
        throw new Error(result.payload?.message ?? 'Internal error')
      }
    }

    refresh()
  }, [dispatch])
}
